<template>
  <router-view/>
</template>
<script>
export default {
  name: 'App',
  mounted() {
    if (!this._isMobile()) {
      console.log("pc端");
      window.location.href = "http://new.byszdd.com";      
    } 
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
}
</script>
<style lang="scss">
html, body, #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 750px;
  height: auto;
  min-height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
p {
  margin: 0;
  padding: 0;
}
ul, li {
  list-style: none;
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
  color: #333;
}

</style>
